import { useMutation } from '@tanstack/react-query';

type ContentItem = { label: string; content: string };

type ParseHtmlResponse = {
  job_content: ContentItem[];
  agent_content: ContentItem[];
  title: string | null;
  company_name: string | null;
};

type ParseHtmlParams = {
  importRequestId: number;
  html: string;
};

export default function useParseHtml() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: ParseHtmlParams) => {
      const response = await fetch(
        `/admin/api/import_requests/${params.importRequestId}/items/parse_html`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token || '',
          },
          body: JSON.stringify({ html: params.html }),
        }
      );
      if (!response.ok) {
        throw new Error('HTMLのパースに失敗しました');
      }
      return (await response.json()) as ParseHtmlResponse;
    },
  });
}
